// 58164
var videourlCarousel = '';
var videourlCarouselAuto = '';
var modalTitle = '';
var modalDescription = '';

$(document).on('click', '.video-carousel-thumbnail .btn-video-popup', function () {
    videourlCarousel = $(this).attr('data-src');
    videourlCarouselAuto = videourlCarousel + "?autoplay=1";
    modalTitle = $(this).attr('data-title');
    modalDescription = $(this).attr('data-description');
});
// #17-378120 #16-378120
$("#videoCarouselModal").on('shown.bs.modal', function () {
    $("#videoCarouselFrame").each(function () {
        (this.contentWindow || this.documentWindow).location.replace(videourlCarouselAuto);
    });
    if (modalTitle) {
        $(".video-carousel-title__modal").text(modalTitle);
    }
    if (modalDescription) {
        $(".video-carousel-description__modal").text(modalDescription);
    }
});

$("#videoCarouselModal").on('hide.bs.modal', function () {
    $("#videoCarouselFrame").each(function () {
        (this.contentWindow || this.documentWindow).location.replace('');
    });
    $(".video-carousel-title__modal").html('');
    $(".video-carousel-description__modal").html('');
});
